import { MapBounds } from '../components/MapView/components/GoogleMap/AuctionsNearMeGoogleMap';

/**
 * Create a bounding box string from MapBounds
 * @param bounds - The MapBounds to create a bounding box string from
 * @returns A string representing the bounding box in the format "swLng,swLat,neLng,neLat"
 */
export const createBoundingBoxString = (bounds: MapBounds): string => {
    return `${bounds.southWest.lng},${bounds.southWest.lat},${bounds.northEast.lng},${bounds.northEast.lat}`;
};
